// extracted by mini-css-extract-plugin
export var actions = "_l5-g";
export var benefitCard = "_l5-b";
export var benefitIcon = "_l5-d";
export var benefitLabel = "_l5-f";
export var benefits = "_l5-a";
export var benefitsSection = "_l5-8";
export var bodyText = "_l5-7";
export var closeButton = "_l5-2";
export var content = "_l5-3";
export var eyebrow = "_l5-4";
export var heading = "_l5-5";
export var image = "_l5-i";
export var imagePanel = "_l5-h";
export var modal = "_l5-0";
export var offerCard = "_l5-c";
export var offerIcon = "_l5-e";
export var sectionLabel = "_l5-9";
export var shell = "_l5-1";
export var title = "_l5-6";